import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/residence_card_2.png")